<template>
  <div class="sgsdg">
    <div :style="{ 'margin-top': '30px', display: 'flex', 'align-items': 'center' }">
      <div :style="{ display: 'flex', 'align-items': 'center' }">
        <div style="margin-right: 10px">选择类别模式</div>
        <CButtons
          :dButtons1="button_1_data"
          :dButtons1_current="select_1_default"
          @Cbtns_sep="select1Change" />
      </div>
      <div :style="{ display: 'flex', 'align-items': 'center', 'margin-left': '10px' }">
        <div style="margin-right: 10px">选择时间颗粒</div>
        <CButtons
          :dButtons1="button_2_data"
          :dButtons1_current="select_2_default"
          @Cbtns_sep="select2Change" />
      </div>
      <div :style="{ display: 'flex', 'align-items': 'center', 'margin-left': '10px' }">
        <div style="margin-right: 10px">选择汇总类型</div>
        <CButtons
          :dButtons1="button_3_data"
          :dButtons1_current="select_3_default"
          @Cbtns_sep="select3Change" />
      </div>

      <el-tooltip class="item" effect="dark" content="每年每个个券平均分红次数" placement="right">
        <i
          class="el-icon-question"
          style="font-size: 20px; margin-left: 16px; color: rgb(64, 158, 255)"></i>
      </el-tooltip>
      <DateTimePick v-model="date_1" :clearable="false" />
      <div style="margin-left: auto; margin-right: 0">
        <Download
          :dButtonsDownloads="dButtonsDownloads2"
          :excel_info="excel_info"
          echartRefName="chart_060645541" />
      </div>
    </div>
    <div class="iconfont icon-fangda" @click="show_chart_dialog = !show_chart_dialog"></div>
    <div
      style="width: 100%; height: 360px; margin-top: 10px"
      ref="chart_060645541"
      v-loading="loading"
      element-loading-text="数据量巨大，正在计算中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 1)"></div>
    <div style="margin-top: 10px">
      <el-table
        class="table1"
        :header-cell-style="tableStyle"
        :data="tabData"
        :height="select_1_default === '大类' ? '' : 460"
        style="width: 100%">
        <el-table-column width="180" label="" prop="name" fixed>
          <template slot-scope="scope">
            <div style="display: flex; align-items: center">
              <div
                :style="{
                  width: '8px',
                  height: '8px',
                  'margin-right': '8px',
                  'border-radius': scope.row.name === '汇总' ? '100%' : '0%',
                  'background-color': chartItemColor(scope.row.name, scope.$index),
                }"></div>
              <span>{{ scope.row.name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          width="90"
          :label="t"
          :prop="t"
          v-for="t in tableColumnKeys"
          :key="t"></el-table-column>
      </el-table>
    </div>
    <ChartDialog :show.sync="show_chart_dialog" :echart_options="chart_options" />
  </div>
</template>

<script>
import CButtons from '../Basic/CButtons_separate.vue';
import DateTimePick from '@/components/Basic/DateTimePick';
import { getDateInfo, debounce } from '@/utils';
import { fnReturnTableStyle } from '@/utils/util';
import Download from '../Basic/Download.vue';
import ChartDialog from '../Basic/ChartDialog.vue';

export default {
  components: { CButtons, DateTimePick, Download, ChartDialog },
  data() {
    const CODELIST = JSON.parse(localStorage.getItem('CODELIST')) || [];
    return {
      CODELIST: Object.freeze(CODELIST),
      show_chart_dialog: false,
      chart_options: {},
      dButtonsDownloads2: Object.freeze([
        {
          id: '241020',
          name: '下载图片',
        },
        {
          id: '241020',
          name: '下载表格',
        },
      ]),
      excel_info: Object.freeze({
        overviewName: '分红情况-按时间趋势',
        excel_data: [],
        json_fields: {},
      }),
      loading: true,
      button_1_data: ['大类', '细分', '个股', '管理人'],
      select_1_default: '大类',
      button_2_data: ['月度', '季度', '年度'],
      select_2_default: '月度',
      button_3_data: ['金额','总数', '平均'],
      select_3_default: '金额',
      date_1: [new Date('2021/6/1'), new Date()],
      page_data: [],
    };
  },
  computed: {
    tabData() {
      if (!this.page_data[0]) return [];
      const { period_fun, ...keys } = this.page_data[0];
      return Object.keys(keys).map((k) => {
        return this.page_data.reduce((p, c) => {
          p.name = k;
          p[c.period_fun] = c[k];
          return p;
        }, {});
      });
    },
    tableColumnKeys() {
      if (!this.tabData[0]) return [];
      const { name, ...t } = this.tabData[0];
      return Object.keys(t);
    },
    tableStyle() {
      const val = this.$store.state.theme === 'dark';
      return () => fnReturnTableStyle(val);
      // return fnReturnTableStyle(val);
    },
    qsStr() {
      const sel_type = {
        大类: 'category_1',
        细分: 'category_2',
        个股: 'name',
        管理人: 'fund_manager',
      }[this.select_1_default];
      const period = {
        月度: 'M',
        季度: 'Q',
        年度: 'Y',
      }[this.select_2_default];
      const nb_type = { 金额:'tamt',总数: 'total', 平均: 'avg' }[this.select_3_default];
      const timeStr = ({ year, month, day }) => {
        if (!year) return '';
        return `${year}-${month}-${day}`;
      };
      const start_date = timeStr(getDateInfo(this.date_1[0]));
      const end_date = timeStr(getDateInfo(this.date_1[1]));
      return new URLSearchParams({ sel_type, period, nb_type, start_date, end_date }).toString();
    },
  },
  watch: {
    qsStr() {
      this.loading = true;
      this.loadData();
    },
    tableColumnKeys() {
      var tabData = JSON.parse(JSON.stringify(this.tabData));
      var json_fields = Object.keys(this.tabData[0]).reduce((p, c) => {
          p[c] = c;
          return p;
        }, {});
      if(this.select_1_default==='个股'){
        tabData.forEach(item=>{
          const code = this.CODELIST.find(({ reitsName }) => reitsName === item.name) || null;
          if(code){
            item.reit_code = code.reitCode;
          }
        });
        var new_json_fields = {};
        for(var key in json_fields){
          new_json_fields[key] = json_fields[key];
          if(key=='name'){
            new_json_fields['reit_code'] = 'reit_code';
          }
        }
        json_fields = new_json_fields;
      }
      this.excel_info = Object.freeze({
        ...this.excel_info,
        excel_data: tabData,
        json_fields: json_fields,
      });
      console.log("TRRRRRRRRRRRRRRR",this.excel_info);
      /* setTimeout(() => {
        const tableEl = document.querySelector('.sgsdg .el-table__body-wrapper.is-scrolling-left');
        tableEl.scroll(tableEl.scrollWidth, 0);
      }, 0); */
    },
  },
  methods: {
    fnGetWidth() {
      var element = document.getElementById('rootchart');
      let ROOTFONTFIZE = element.offsetWidth;
      ROOTFONTFIZE = ROOTFONTFIZE > 1440 ? 1440 : ROOTFONTFIZE;
      ROOTFONTFIZE = ROOTFONTFIZE < 1400 ? ROOTFONTFIZE - 200 : ROOTFONTFIZE;
      this.ROOTFONTFIZE = ROOTFONTFIZE / 10;
    },
    resize() {
      this.fnGetWidth();
      this.echart_instance && this.echart_instance.resize();
    },
    select1Change(v) {
      this.select_1_default = v;
    },
    select2Change(v) {
      this.select_2_default = v;
    },
    select3Change(v) {
      this.select_3_default = v;
    },
    loadData: debounce(async function () {
      const { data } = await this.$https.get(`/api/v2_5/div_bar_timeseries?${this.qsStr}`);

      if (data.code !== 200) return this.$message.error(data.msg);
      this.page_data = Object.freeze(data.data);
      this.loading = false;
      setTimeout(() => {
        const tableEl = document.querySelector('.sgsdg .el-table__body-wrapper.is-scrolling-left');
        tableEl.scroll(tableEl.scrollWidth, 0);
      }, 300);
      setTimeout(() => {
        this.renderEcharts();
      }, 0);
    }, 600),
    chartItemColor(name, index) {
      if (name === '汇总') {
        return '#df8940';
      } else if (this.select_1_default === '个股') {
        //个股颜色
        const item = this.CODELIST.find(({ reitsName }) => reitsName === name) || {};
        return this.colors_2[item.reitsTypeL2] || '#bfabfa';
      } else if (this.select_1_default === '管理人') {
        return [
          '#46b1e1',
          '#5ae8ed',
          '#aeaeae',
          '#0f9ed5',
          '#1f8ec0',
          '#46b1e1',
          '#46b1e1',
          '#0b76a0',
          '#5e5ce6',
          '#0d3a4e',
          '#9492ee',
          '#4ea72e',
        ][index % 12];
      } else {
        return this.colors_2[name] || '#bfabfa';
      }
    },
    renderEcharts() {
      if (!this.page_data.length) {
        this.echart_instance && this.echart_instance.clear();
        return;
      }
      if (!this.echart_instance) {
        this.echart_instance = this.$echarts.init(this.$refs.chart_060645541);
      }
      this.echart_instance.clear();

      const colors = this.$store.state.colors || [];
      this.colors_2 = colors.reduce((p, c) => {
        p[c.name] = c.value;
        return p;
      }, {});

      let startValue = this.page_data.length;
      let endValue = this.page_data.length - 12;
      if (this.select_1_default === '个股') {
        endValue = startValue - 2;
      } else if (this.select_1_default === '管理人') {
        endValue = startValue - 2;
      }
      const t_3  = this.select_3_default;
      let OPTIONDATA =
        this.$store.state.theme == 'dark'
          ? this.$store.state.OPTIONDATA
          : this.$store.state.OPTIONDATA_light;

      const options = {
        dataset: [
          {
            dimensions: Object.keys(this.page_data[0]),
            source: this.page_data,
          },
        ],
        xAxis: {
          type: 'category',
          // show: false,
          axisLabel: {
            interval: 0,
            rotate: 0,
            margin: OPTIONDATA.xAxis.axisLabel.margin,
            fontSize: OPTIONDATA.xAxis.axisLabel.fontSize,
            showMaxLabel: true,
            color: OPTIONDATA.xAxis.axisLabel.color,
          },
        },
        yAxis: {
          name: t_3==='金额'?'单位（万元）':'单位（次）',
          nameTextStyle: {
            color: OPTIONDATA.yAxis.nameTextStyle.color,
            fontSize: OPTIONDATA.yAxis.nameTextStyle.fontSize,
          },
          // show: false,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            fontSize: OPTIONDATA.yAxis.axisLabel.fontSize,
            show: true,
            color: OPTIONDATA.yAxis.axisLabel.color,
          },
          splitLine: OPTIONDATA.yAxis.splitLine,
        },
        // legend: {},
        toolbox: {
          // 工具箱按钮
          right: 30,
          top: -5,
          itemSize: 18,
          iconStyle: {
            borderColor: OPTIONDATA.toolbox.iconStyle.borderColor,
          },
          feature: {
            dataZoom: {}, // 区域缩放
          },
        },
        tooltip: {
          trigger: 'axis',
          // 柱状高亮
          axisPointer: {
            type: 'shadow',
          },
          formatter: (params) => {
            const name = params[0].name;
            const items = params
              .filter(({ seriesName, value }) => !!value[seriesName])
              .map(({ marker, seriesName, value }) => {
                return `<div>${marker} ${seriesName}<span style="margin-left:10px">${value[seriesName]}</span></div>`;
              })
              .join('');
            return `${name}<br/>
              <div style="columns:${params.length >= 21 ? 3 : 1}">
              ${items}
              </div>
              `;
          },
        },
        grid: {
          top: this.ROOTFONTFIZE * (30 / 144),
          left: this.ROOTFONTFIZE * (35 / 144),
          right: this.ROOTFONTFIZE * (60 / 144),
          bottom: this.ROOTFONTFIZE * (30 / 144),
          containLabel: true,
        },
        dataZoom: {
          // 开启数据平移qc
          type: 'slider', // 滑动条单独显示
          show: true, // 是否显示滑动条
          startValue, // 展示区域内容的起始数值
          endValue, // 展示区域内容的结束数值 当前展示x坐标下标为0-16
          height: this.ROOTFONTFIZE * (5 / 144), // 滑动条组件高度
          bottom: this.ROOTFONTFIZE * (20 / 144), // 距离图表区域下边的距离
          showDetail: false, // 拖拽时是否显示详情
          showDataShadow: false,
          fillerColor: '#D4D4D4', // 平移条的填充颜色
          borderColor: 'transparent', // 边框颜色
          zoomLock: true, // 锁定视图
          brushSelect: false, // 不可缩放 滑动条默认是有手柄可以进行展示的内容区域缩放的，不太美观
          // 通过该属性可以只滑动，不显示缩放功能
          handleStyle: {
            opacity: 0,
          },
          lineStyle: {
            opacity: 0,
          },
          textStyle: {
            fontSize: 0,
          },
        },
        series: Object.keys(this.page_data[0])
          .filter((k) => k !== 'period_fun')
          .sort((a, b) => {
            // 汇总 放最后显示
            const m = { 汇总: 999 };
            return m[a] || 0 - m[b] || 0;
          })
          .map((k, i) => ({
            name: k,
            type: k !== '汇总' ? 'bar' : 'line',
            encode: { x: 'period_fun', y: k },
            symbol: 'circle',
            symbolSize: this.ROOTFONTFIZE * (12 / 144),
            itemStyle: {
              color: () => this.chartItemColor(k, i),
            },
            lineStyle: {
              width: 0,
            },
          })),
      };
      this.echart_instance.setOption(options);
      this.echart_instance.resize();
      this.chart_options = Object.freeze(options);
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
    this.echart_instance && this.echart_instance.dispose();
  },
  mounted() {
    this.loadData();
    this.resize();
    window.addEventListener('resize', this.resize);
  },
};
</script>

<style scoped lang="less">
/deep/.el-table__fixed::before {
  background-color: transparent;
}
.sgsdg {
  position: relative;
  .container {
    margin-left: 0;
  }

  .icon-fangda {
    position: absolute;
    right: 8px;
    top: 54px;
  }
}
</style>
